import { render, staticRenderFns } from "./agendar_consulta.vue?vue&type=template&id=5b3d4382"
import script from "./agendar_consulta.vue?vue&type=script&lang=js"
export * from "./agendar_consulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports